import { defineStore } from 'pinia'

export const UserStore = defineStore('giga_user', {
    state: () => {
        return { giga_user: null }
    },
    actions: {
        get() {
            return this.giga_user
        },
        set(value) {
            this.giga_user = value
        }
    },
})